// extracted by mini-css-extract-plugin
module.exports = {"sliderWrap":"SliderSelect_sliderWrap__FSR4s","slider":"SliderSelect_slider__3ZC4I","sliderThumb":"SliderSelect_sliderThumb__1OCUx","sliderTrack":"SliderSelect_sliderTrack__1te4j"};